import { render, staticRenderFns } from "./HRPrefer.vue?vue&type=template&id=7d4364aa&scoped=true"
import script from "./HRPrefer.vue?vue&type=script&lang=js"
export * from "./HRPrefer.vue?vue&type=script&lang=js"
import style0 from "./HRPrefer.vue?vue&type=style&index=0&id=7d4364aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4364aa",
  null
  
)

export default component.exports